import React, { forwardRef, Children } from 'react';
import BadgeStyled from './bundle.esm2.js';
import { getItemPositioning } from '../../utils/bundle.esm3.js';

const Badge = forwardRef((props, ref) => {
  const { className, position = "top-right", title, children, value } = props;
  if (Children.count(children) > 1) {
    console.error("You must provide only one children element");
    return null;
  }
  return /* @__PURE__ */ React.createElement(BadgeStyled, {
    className: `Badge ${className}`,
    position: getItemPositioning("top-right", position),
    title,
    ref
  }, /* @__PURE__ */ React.createElement("div", {
    className: "Badge__value"
  }, value), children);
});
Badge.defaultProps = {
  className: "",
  position: "top-right"
};

export { Badge as default };
//# sourceMappingURL=bundle.esm.js.map
